export const WEB_STORAGE_NAMES = {
  UserInfo: "UserInfo",
  StoresList: "StoresList",
  CartItems: "CartItems",
  OrderNumber: "OrderNumber",
  OrderTypeDetails: "OrderTypeDetails",
};

export const USER_ROLES = {
  ShopAdmin: "Shop.Admin",
  ShopUser: "Shop.User",
  ShopCustomer: "Shop.Customer",
};
